import { ConcurrentExperience } from '@atlaskit/ufo/concurrent-experience';
import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlaskit/ufo/experience-types';

/**
 * JSM (Jira Service Management) live chat specific UFO experiences
 * These experiences track user interactions related to live chat functionality
 * in the JSM context.
 */
export const JSM_AI_WIDGET_STORE_UFO_EXPERIENCES: {
	readonly INITIALIZE_LIVE_CHAT: ConcurrentExperience;
	readonly EXIT_LIVE_CHAT: ConcurrentExperience;
} = {
	INITIALIZE_LIVE_CHAT: new ConcurrentExperience('jsm-helpseeker-initialize-live-chat', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
	EXIT_LIVE_CHAT: new ConcurrentExperience('jsm-helpseeker-exit-live-chat', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
} as const;
